// @ts-strict-ignore
import classNames from 'classnames'
import React from 'react'
import { Icon } from '@blueprintjs/core'
import { Popover } from './ui/popover'
type ClassValue = classNames.Argument

interface SelectBoxesProps {
    value: number
    onChange: (number, ...any) => void
    options: SelectBoxOption[]
    className?: ClassValue
    contentProps?: object
}

export interface SelectBoxOption {
    label: string
    value: number
    disabled?: boolean
    tooltip?: string | JSX.Element
    content?: Content
}

export type Content = (any) => JSX.Element
export const SelectBoxes = ({
    value,
    onChange,
    options,
    className,
    contentProps,
}: SelectBoxesProps) => {
    return (
        <div className={classNames('flex', className)}>
            {options.map((o, i) => (
                <SelectBox
                    key={i}
                    {...o}
                    active={value === o.value}
                    onChange={onChange}
                    contentProps={contentProps}
                />
            ))}
        </div>
    )
}

interface SelectBoxProps {
    label: string
    value: number
    active: boolean
    disabled?: boolean
    onChange: (number, any?) => void
    className?: ClassValue
    tooltip?: string | JSX.Element

    // content is an optional functional component that will be rendered below the label.
    // generally used for input components needed in the select box (ie radios, text input, etc)
    content?: Content
    contentProps?: object
}

const SelectBox = (props: SelectBoxProps) => {
    const { onChange, label, value, active, disabled, className, tooltip, content, contentProps } =
        props

    const classes = classNames(
        'px-4 py-6 rounded-md transition-colors duration-200',
        'mr-4 relative flex flex-col items-center',
        className,
        {
            'bg-gray-100 cursor-not-allowed': disabled,
            'bg-white-not-important cursor-pointer': !disabled,
            'hover:bg-mjGreen-100 hover:border-mjGreen-500': !disabled && !active,
            'border-1': !active,
            'bg-mjGreen-100 border-mjGreen-500 border-2': active,
        },
    )

    const contentOnChange = (...v) => {
        onChange(value, ...v)
    }

    const renderedContent =
        typeof content !== 'undefined' && active
            ? content({
                  onChange: contentOnChange,
                  ...contentProps,
              })
            : null

    let selectBox = (
        <div
            className={classes}
            onClick={() => {
                !disabled && !active ? onChange(value) : null
            }}
        >
            {active && (
                <div className="absolute top-1 right-1">
                    <Icon icon="tick" color={'#20A38D'} />
                </div>
            )}
            <div className="semi-bold">{label}</div>
            {/* @todo animate*/}
            <div>{active && renderedContent}</div>
        </div>
    )

    if (tooltip) {
        let renderedTooltip = tooltip
        if (typeof renderedTooltip === 'string') {
            renderedTooltip = <div className="p-2">{renderedTooltip}</div>
        }

        selectBox = (
            <Popover content={renderedTooltip} interactionKind="hover">
                {selectBox}
            </Popover>
        )
    }

    return selectBox
}
